export const BASE_PATH = process.env.NODE_ENV === 'production' ? '' : '';
